<template>
  <div class="PageSelfStudyRoom m-hp-100 m-fb-col m-hidden m-fb-cross-center">
    <CommonHeader title='"X" 空间'></CommonHeader>
    <CommonBox class="m-item-flex-1 m-hp-100 m-fb m-hidden" v-if="isInitDoneFlag">
      <!-- 筛选条件 -->
      <div class="m-w-274 m-p-24-0 m-hidden">
        <div class="m-p-0-24 m-auto m-hp-100">
          <div class="m-border-bottom m-pb-24">
            <SelfRoomClassify
              @submit="handlerSubmit"
              :roomType="roomType"
              @handlerDefaultData="handlerDefaultData"
            ></SelfRoomClassify>
          </div>
          <!-- 室内配套 -->
          <div class="m-p-24-0 m-pl-16 m-border-bottom">
            <div class="m-fb-between-center m-mb-16">
              <span class="m-font-14 m-bold">室内配套</span>
              <span
                class="m-font-12 m-c-003F88 m-pointer"
                @click="handlerClean('selfRoomResourceIdList')"
                v-if="postData.selfRoomResourceIdList.length"
                >清除选项</span
              >
            </div>
            <m-checkbox
              class="checkbox"
              :class="{ 'm-mb-10': index !== resourcesList.length - 1 }"
              :label="res.paramName"
              v-model="postData.selfRoomResourceIdList"
              v-for="(res, index) in resourcesList"
              :checkVal="res.baseConfigId"
              :key="res.buildingId"
              @change="initSelfRoomList"
            ></m-checkbox>
          </div>
          <!-- 周边配套 -->
          <div class="m-p-24-0 m-pl-16">
            <div class="m-fb-between-center m-mb-16">
              <span class="m-font-14 m-bold">周边配套</span>
              <span
                class="m-font-12 m-c-003F88 m-pointer"
                @click="handlerClean('surroundingFacilitiesList')"
                v-if="postData.surroundingFacilitiesList.length"
                >清除选项</span
              >
            </div>
            <m-checkbox
              class="checkbox"
              :class="{ 'm-mb-10': index !== supportList.length - 1 }"
              :label="res.paramName"
              v-model="postData.surroundingFacilitiesList"
              v-for="(res, index) in supportList"
              :checkVal="res.baseConfigId"
              :key="res.buildingId"
              @change="initSelfRoomList"
            >
            </m-checkbox>
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div class="m-item-flex-1 m-hidden m-fb-col">
        <div class="m-mt-24">
          <MSearchBox
            v-model="postData.selfRoomName"
            placeholder="请搜索楼宇/房间名称"
            class="m-w-240"
            maxlength="30"
          ></MSearchBox>
        </div>
        <!-- 有楼宇的时候才有自习室 -->
        <template v-if="studyRoomlist && studyRoomlist.length">
          <m-scroll class="m-item-flex-1" :options="{ width: 4 }" ref="myScroll">
            <div v-for="(it, index) in studyRoomlist" :key="index" class="m-p-24-0 m-pr-24">
              <p class="build-tip m-p-10-0 m-p-0-22" :class="{ 'm-mt-24': index }">
                <span class="m-font-16"> {{ it.buildingName }}</span>
                <span class="m-c-666666 m-pl-32 tip m-font-14" v-if="it.facilitiesList">
                  {{ methodShowTypeName(it.facilitiesList) }}</span
                >
              </p>
              <SelfRoomBox
                class="m-mt-24"
                :studyRoomData="studyRoomItem"
                v-for="studyRoomItem in it.userEduSelfRoomDtoList"
                :key="studyRoomItem.selfRoomId"
              ></SelfRoomBox>
            </div>
          </m-scroll>
          <div class="m-p-15-0 m-border-top m-fb-end-center m-pr-24">
            <MPagination
              :current-page="currentPage"
              :total="total"
              :page-size="pageSize"
              :pageSizeList="pageSizeList"
              @change-page="handlerToChangePage"
            ></MPagination>
          </div>
        </template>
        <template v-else>
          <CommonNoData tips="未搜索到相关空间" type="search"></CommonNoData>
        </template>
      </div>
    </CommonBox>
  </div>
</template>
<script>
import { web, selfRoom } from '@/mixin'
export default {
  mixins: [web, selfRoom],
  data() {
    return {
      iconUrl: require('@/assets/imgs/icon/longCorridor.png'),
      listFunc: this.fetchCorridorList,
      roomType: 3 //惟学长廊
    }
  },

  methods: {
    initSelfRoomList() {
      this.currentPage = 1
      this.fetchCorridorList()
    },
    // 长廊列表
    async fetchCorridorList() {
      try {
        let _postData = JSON.parse(JSON.stringify(this.postData))
        _postData.paginator = {
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        let _res = (await this.$httpPost('selfroomCorridorList', _postData)) || {}
        this.studyRoomlist = _res.list || []
        this.total = (_res.paginator || {}).total || 0
      } catch (error) {
        console.log(error)
      } finally {
        this.$nextTick(() => {
          this.$refs.myScroll && this.$refs.myScroll.scrollTop()
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.PageSelfStudyRoom {
  .checkbox {
    display: block;
  }
  .build-tip {
    background: rgba(0, 63, 136, 0.04);
    .tip {
      position: relative;
      &::before {
        content: '';
        display: inline-block;
        width: 1px;
        height: 20px;
        background: #dddddd;
        left: 16px;
        position: absolute;
        top: 0;
      }
    }
  }
  .classifybox {
    position: relative;
    .SelfRoomClassify {
      position: absolute;
      z-index: 10;
      left: 48px;
      top: 42px;
    }
  }
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
